import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkChangeEntry } from '../types';

const onRestoreEntry: IThunkChangeEntry = thunk(async (_, { entryId, ...client }) => {
  await api.communityEngagement.recoverEntry(client, entryId);
});

export default onRestoreEntry;
